import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import {
  OrganizationTrainingConfig,
  UpdateOrganizationTrainingConfigRequest,
} from '../../../_types/training';

export async function updateOrganizationTrainingConfig(
  orgId: string,
  config: OrganizationTrainingConfig
): Promise<OrganizationTrainingConfig> {
  if (!orgId) throw new Error('No organization ID provided.');

  const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/training/config`;

  // Transform internal config to API format: extract enabled module IDs as planIds
  const requestBody: UpdateOrganizationTrainingConfigRequest = {
    planIds: config.modules.filter((module) => module.status === 'ENABLED').map((module) => module.id),
  };

  try {
    await fetcher({
      method: 'PUT',
      url,
      body: requestBody,
    });
    // Return the original config since API doesn't return the full config
    return config;
  } catch (error: unknown) {
    if (typeof error === 'object' && error !== null && 'errorDetails' in error) {
      throw error as ServerErrorResponse;
    }
    throw error;
  }
}


